export default __webpack_public_path__ + "static/media/girl_and_dog.541a62db.png";